import * as FileSaver from 'file-saver';
import XLSX from 'sheetjs-style';

export const exportToExcel = async (dataExport = [], fileName) => {
  // Para mayor información, consultar https://www.npmjs.com/package/sheetjs-style
  const fileType = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
  const fileExtension = '.xlsx';
  const ws = XLSX.utils.json_to_sheet(dataExport);

  // De esta manera se aplican estilos a una celda en particular:
  // ws['A1'].s = {
  //   font: {
  //     sz: 11,
  //     bold: true
  //   },
  //   alignment: { vertical: 'center' }
  // };

  // ws['B1'].s = {
  //   font: {
  //     sz: 11,
  //     bold: true
  //   },
  //   alignment: { vertical: 'center' }
  // };

  const wb = { Sheets: { Data: ws }, SheetNames: ['Data'] };

  // Seteamos el ancho de cada columna:
  wb.Sheets.Data['!cols'] = [
    { wpx: 130 },
    { wpx: 70 },
    { wpx: 90 },
    { wpx: 110 },
    { wpx: 140 },
    { wpx: 145 },
    { wpx: 100 },
    { wpx: 100 }
  ];

  // De ésta forma seteamos el alto de la primera fila:
  // wb.Sheets.Data['!rows'] = [{ hpx: 20 }];

  // Seteamos el alto de todas las filas:
  const rowsHeight = () => {
    const lengthData = dataExport.length;
    const rows = [];
    for (let rowNumber = 0; rowNumber <= lengthData; rowNumber += 1) {
      rows.push({ hpx: 17 });
    }
    return rows;
  };

  wb.Sheets.Data['!rows'] = rowsHeight();

  const excelBuffer = XLSX.write(wb, { bookType: 'xlsx', type: 'array' });
  const data = new Blob([excelBuffer], { type: fileType });
  FileSaver.saveAs(data, fileName + fileExtension);
};
